import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../../store/SettingSlice';
import { getImgPath } from '../../store/JSTool';
import * as APJHttp from '../../store/APJHttp';

let latestCacheAry = null;

export default function NewsSectionView() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);
    const [dataAry, setDataAry] = React.useState([]);

    React.useEffect(() => {
        if (latestCacheAry == null) {
            APJHttp.getLatestNews(4, (res) => {
                latestCacheAry = res.data;
                setDataAry(res.data);
            }, (code, msg) => {
                dispatch(settingActions.showToast(`code ${code}: ${msg}`));
            })
        } else {
            setDataAry(latestCacheAry);
        }
    }, []);

    function tap(newsId) {
        navigate(`/newsDetail?id=${newsId}`)
    }

    return (
        <Stack sx={{
            width: 1,
            bgcolor: '#EBEBEB',
            justifyContent: 'center',
            alignItems: 'center',
            pb: 2,
            display: dataAry.length > 0 ? 'flex' : 'none',
        }}>
            {/* 上边 */}
            <Stack sx={{
                flexDirection: 'row',
                alignItems: 'center',
                width: '1200px',
                mt: 3,
            }}>
                {/* 大图 */}
                <Box
                    onClick={() => {
                        if (dataAry.length > 0) {
                            tap(dataAry[0].id);
                        }
                    }}
                    component={'img'}
                    src={dataAry.length > 0 && getImgPath(dataAry[0].image_url)}
                    sx={{
                        width: '790px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.013)',
                        }
                    }} />

                {/* 右边 */}
                <Stack sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    ml: 5,
                }}>
                    <Typography sx={{
                        fontFamily: 'Lexend Deca',
                        fontSize: 40
                    }}>
                        {dataAry.length > 0 && dataAry[0].display_time}
                    </Typography>

                    <Typography sx={{
                        fontFamily: 'Source Han Sans CN',
                        fontSize: 20,
                        mt: 2,
                    }}>
                        {dataAry.length > 0 && dataAry[0].title}
                    </Typography>

                    {/* 按钮 */}
                    <Stack
                        onClick={() => {
                            tap(7);
                        }}
                        sx={{
                            height: '60px',
                            minWidth: '210px',
                            bgcolor: 'black',
                            borderRadius: '8px',
                            mt: 5,
                            color: 'white',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                            position: 'relative',
                            flexDirection: 'row',
                            transitionDuration: '0.3s',
                            '&:hover': {
                                transform: 'scale(1.04)',
                            }
                        }}>
                        <Typography sx={{
                            fontFamily: settingData.fontFM,
                            fontSize: 19,
                        }}>
                            {settingData.langDic['lang9']}
                        </Typography>

                        <Box component={'img'}
                            src={getImgPath('arrow_right.png')}
                            sx={{
                                ml: 1.5,
                                right: '25px',
                                height: '15px',
                            }} />
                    </Stack>

                </Stack>

            </Stack>

            {/* 下边 */}
            <Stack
                sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '1200px',
                    mt: 3,
                    display: dataAry.length >= 3 ? 'flex' : 'none',
                }}>
                <NewsItem item={dataAry[1]}  color='#FF5F47' />
                <Box sx={{ width: '80px' }} />
                <NewsItem item={dataAry[2]}  color='#F09530' />
                <Box sx={{ width: '80px' }} />
                <NewsItem item={dataAry[3]}  color='#FFC817' />
            </Stack>

            <Stack sx={{
                mt: 1.5,
                width: '1200px',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
            }}>
                <Typography
                    onClick={() => {
                        dispatch(settingActions.setNavIndex(2));
                        navigate('/newsList');
                    }}
                    sx={{
                        fontFamily: settingData.fontFM,
                        cursor: 'pointer',
                        fontSize: 22,
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.08)',
                        }
                    }}>
                    {settingData.langDic['lang10']}
                </Typography>

                <Box component={'img'}
                    src={getImgPath('arrow_right_black.png')}
                    sx={{
                        ml: 0.5,
                        height: '17px',
                        cursor: 'pointer',
                    }} />

            </Stack>

        </Stack>
    );
}

function NewsItem(props) {
    const navigate = useNavigate();

    function itemTap() {
        // if (props.index == 0) {
        //     window.open('https://eu.onepunchmanworld.com');
        // } else if (props.index == 1) {
        //     window.open('https://www.sfduelmobile.com');
        // } else if (props.index == 2) {
        //     window.open('https://www.sfduelmobile.com');
        // }

        navigate(`/newsDetail?id=${props.item.id}`)
    }

    return (
        <Stack
            onClick={itemTap}
            sx={{
                cursor: 'pointer',
            }}>
            <Box component={'img'}
                src={props.item && getImgPath(props.item.image_url)}
                sx={{
                    width: 1,
                    borderRadius: '6px',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.02)',
                    }
                }} />

            <Typography sx={{
                fontFamily: 'Lexend Deca',
                fontSize: 24,
                mt: 1,
                textAlign: 'end'
            }}>
                {props.item && props.item.display_time}
            </Typography>

            <Typography sx={{
                fontFamily: 'Source Han Sans CN',
                fontSize: 15,
                fontWeight: 'bold',

            }}>
                {props.item && props.item.title}
            </Typography>

            <Box sx={{
                mt: 1,
                height: '8px',
                bgcolor: props.color
            }} />
        </Stack>
    );
}